import { Alert, Skeleton } from "@mui/material";
import type { FC } from "react";
import type { MomentFormMoment } from "../../../modules/moment/types/moment-form-moment";
import { MomentPollsContextProvider, useMomentPollsContext } from "./context/moment-polls-context";
import { MomentPoll } from "./moment-poll";

const MomentPollsInner: FC = () => {
  const { error, loading, data } = useMomentPollsContext();
  if (loading) {
    return (
      <Skeleton
        data-testid="polls-content-skeleton"
        animation="wave"
        variant="rounded"
        height={250}
      />
    );
  }
  if (error) {
    return <Alert severity="error">Error loading Polls results</Alert>;
  }

  if (!data || !data.length) {
    return <Alert severity="info">No poll results available for this moment</Alert>;
  }
  return data.map((poll) => <MomentPoll key={poll.poll_id} {...poll} />);
};

export const MomentPollsTab: FC<{ moment: MomentFormMoment }> = ({ moment }) => {
  return (
    <MomentPollsContextProvider moment={moment}>
      <MomentPollsInner />
    </MomentPollsContextProvider>
  );
};
